import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatListModule } from '@angular/material/list';
import { RouterModule } from '@angular/router';

import {
  CollectionComponent,
  FooterComponent,
  FormComponent,
  HeaderComponent,
  ListComponent,
} from './components';

const components = [
  CollectionComponent,
  FooterComponent,
  FormComponent,
  HeaderComponent,
  ListComponent,
];

@NgModule({
  imports: [CommonModule, MatListModule, RouterModule],
  declarations: [...components],
  exports: [...components],
})
export class CollectionModule {}
